<template>
  <div>
    <div class="top">
      <Breadcrumb :options="breadcrumb" />
      <Wxts :wxtsList="wxtsList" />
    </div>

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <template #end>
        <el-form-item>
          <el-button class="allRecord" type="primary" @click="goPaymentRecord">全部打款记录</el-button>
        </el-form-item>
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :showTotal="true"
      :getTotal="getTotal" :btns="btns" @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange">
      <template #paytime="params">{{ params.params.paytime ? params.params.paytime.slice(0, 10) : "-" }}</template>
    </Table>

    <FormDialog ref="dialog" :title="title" :width="'570px'" :labelWidth="'110px'" :form="mform" :rules="mrules"
      :formCtrl="mformCtrl" :viewMode="viewMode" @onModalSubmit="onModalSubmit"></FormDialog>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";
import Wxts from '../../../components/Wxts.vue';
export default {
  name: "FinanceInitialPayment",
  components: { Wxts },
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: "car",
      breadcrumb: [
        { name: "财务管理", path: `/finance/initialPayment` },
        { name: "预支款管理", path: `/finance/initialPayment` },
      ],
      wxtsList: [
        {
          name:'运单完成后扣减预支款'
        },
      ],
      formInline: {},
      formCtrl: [
        {
          ...this.ctrls.fleet,
          label: "车队长",
          placeholder: "",
          options: [],
        },
        {
          ...this.ctrls.license,
        },
        {
          label: "预支款最低值",
          keyName: "settled",
          placeholder: "请填写金额",
          type: "text",
        },
      ],
      cols: [
        { keyName: "license", label: "车牌号"},
        { keyName: "driver", label: "司机姓名" },
        { keyName: "carstatus", label: "车辆状态" },
        { keyName: "money", label: "预支款余额", align: 'right', className: 'pr30'},
        { keyName: "paytime", label: "最近打款日期", slot: "paytime" },
        { keyName: "vtype", label: "车辆类型" },
      ],
      getTotalProperty: ["money"],
      btns: [
        {
          title: "费用明细",
          img: require('@/assets/img/icon-fee-detail.png'),
          unimg: require('@/assets/img/icon-fee-detail-hover.png'),
          cb: ({ license }) => {
            this.$router.push(
              `/finance/initialPaymentDetailList?license=${license}`
            );
          },
        },
        {
          //...this.viewBtn,
          title: "打款记录",
          img: require('@/assets/img/shipper_order_list.png'),
          unimg: require('@/assets/img/shipper_order_list_hover.png'),
          cb: ({ id, license }) => {
            this.$router.push(
              `/finance/initialPaymentRecord?id=${id}&license=${license}`
            );
          },
        },
        {
          //...this.editBtn,
          title: "打款",
          img: require('@/assets/img/initialPayment_01.png'),
          unimg: require('@/assets/img/initialPayment_01_hover.png'),
          cb: ({ id, license, money }) => {
            // console.log(id, license, money)
            this.mform = {
              ...this.mform,
              id,
              license,
              money,
              photo: undefined,
            };
            this.$forceUpdate();
            this.showDialog();
            // console.log({ ...this.mform })
          },
        },
      ],
      title: "添加打款记录",
      viewMode: false,
      mform: {
        paymoney: undefined,
        photo: undefined,
      },
      mrules: {
        paymoney: [
          {
            required: true,
            message: '请填写打款金额',
            trigger: 'blur',
          }
        ],
        photo: [
          {
            required: true,
            message: '请上传打款凭证',
            trigger: 'blur',
          }
        ],
      },
      mformCtrl: [
        {
          ...this.ctrls.license,
          label: "车牌号",
          disabled: true,
        },
        {
          label: "余款",
          keyName: "money",
          err: "请填写余款",
          type: "number",
          disabled: true,
        },
        {
          label: "打款金额",
          keyName: "paymoney",
          err: "请填写打款金额",
          type: "number",
        },
        {
          label: "打款凭证",
          keyName: "photo",
          tips: "最多上传2张图片",
          type: "file",
          ptype: "advance",
          max: 2,
        },
        {
          label: "备注",
          keyName: "remark",
          err: "请填写备注信息",
          type: "textarea",
          rows: 3,
        },
      ],
      getListUrl: "moneyrec",
    };
  },
  methods: {
    goPaymentRecord() {
      this.$router.push(`/finance/initialAllPaymentRecord`);
    },
    onModalSubmit() {
      console.log({ ...this.mform });
      const { photo, paymoney, id, remark } = this.mform;
      if (!photo || !photo.length) {
        this.$message({
          type: "warning",
          message: "请上传打款图片！",
        });
      }
      if (!paymoney) {
        this.$message({
          type: "warning",
          message: "请填写打款金额！",
        });
      }
      let url = `car/addmoney`;
      const params = {
        userid: this.user.id,
        cid: id,
        paymoney,
        remark,
      };
      params['photo'] = photo.map(v => {
        let result = v
        if (v.response && v.response.photo) {
          result = { url: v.response.photo }
        }
        return result
      })
      this.loading = true;
      this.post(
        url,
        params,
        ({ msg }) => {
          if (msg === "success") {
            this.$message({
              type: "success",
              message: "提交成功!",
            });
            this.hideDialog();
            this.getList();
          } else {
            this.$message({
              type: "error",
              message: msg,
            });
          }
        },
        (err) => {
          console.log(err);
          this.$message({
            type: "error",
            message: "提交数据失败，请稍后重试！",
          });
        }
      );
    },
  },
  mounted() {
    this.getFleet();
    const { user_group_id,id } = this.user
    if ([5].includes(user_group_id)) {
      this.btns.length = 1
      this.formInline.fleet = id
    }
  },
};
</script>

<style lang="less" scoped>
.top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 20px;
}

/deep/ .fillet {
  .retrieval {
    .allRecord {
      width: 120px;
    }
  }
}

.dialog {
  .el-form {
    padding-right: 50px;
  }

  .btns {
    margin-left: 110px;
  }
}

/deep/ .el-dialog .btns .mians {
  text-align: center;
}
</style>
